import {GRCPage} from './GRC.jsx';
export default GRCPage;
